var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.667 12.667h8.666a.667.667 0 1 1 0 1.333H3.667a.667.667 0 1 1 0-1.333zM14.517 5c-.635 0-1.15.504-1.15 1.125 0 .166.038.321.105.464l-1.734 1.017a.775.775 0 0 1-1.06-.272L8.727 3.992c.256-.206.424-.515.424-.867C9.15 2.504 8.635 2 8 2c-.635 0-1.15.504-1.15 1.125 0 .352.168.66.424.867L5.321 7.334a.776.776 0 0 1-1.058.272L2.53 6.59a1.11 1.11 0 0 0 .106-.464C2.636 5.504 2.12 5 1.486 5 .85 5 .333 5.504.333 6.125a1.138 1.138 0 0 0 1.335 1.106L3.4 11.75h9.2l1.732-4.519a1.138 1.138 0 0 0 1.334-1.106c0-.621-.514-1.125-1.15-1.125z",
    fill: "#FFD044"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrown);
export default __webpack_public_path__ + "static/media/icon-crown.d5e05350.svg";
export { ForwardRef as ReactComponent };